/*
 * @Description: 一周用户情感倾向趋势
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 11:27:35
 * @LastEditTime: 2019-09-20 16:47:34
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p8.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts';

import {getUserFeelings} from '../../../controller';
import {emotionalTendencyPolar, emotionalTendencyBar} from '../../../chart';
import { getSessionQuery } from '../../../utils';
import moment from 'moment';

class P8 extends React.Component {
  constructor () {
    super();

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        better: '',
        ne: '',
        worse: '',
        maxShunDate: '',
        maxNiDate: '',
        like: Boolean,
        neutral: String,
        niyi_per: String,
        platform: String,
        pleasant: String,
        shunyi_per: String,
        unpleasant: String,
        zhongli_per: String
      },
      polar: {},
      bar: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.industry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result

  }

  getData () {
    const query = this.getQuery();
    getUserFeelings(Object.assign({report:true}, query))
      .then(data => {
        const highlight = data.highlight;
        const allScale = highlight.allScale;
        this.setState({
          query: query,
          summary: {
            better: allScale.better,
            ne: allScale.ne,
            worse: allScale.worse,
            maxShunDate: highlight.maxShunDate,
            maxNiDate: highlight.maxNiDate,
            like: highlight.like,
            neutral: highlight.neutral,
            niyi_per: highlight.niyi_per,
            platform: highlight.platform,
            pleasant: highlight.pleasant,
            shunyi_per: highlight.shunyi_per,
            unpleasant: highlight.unpleasant,
            zhongli_per: highlight.zhongli_per
          },
          polar: emotionalTendencyPolar(data, query),
          bar: emotionalTendencyBar(data)
        })
      })
  }

  render() {
    const {query, summary} = this.state;
    return (
      <div className={s.container}>
        <ExportHeadTitle>一周用户情感倾向趋势</ExportHeadTitle>

        <div>
          <ExportDes>本周，{query.brandName}
            品牌的受众整体情感倾向是：顺意群体占{summary.shunyi_per} （{summary.pleasant}全网顺意均值{summary.better}），
            中立群体占{summary.zhongli_per}（{summary.neutral}全网中立均值{summary.ne}），
            逆意群体占{summary.niyi_per}（{summary.unpleasant}全网逆意均值{summary.worse}）。
            顺意群体在{moment(summary.maxShunDate).format('M月D日')}达到最多，
            逆意群体在{moment(summary.maxNiDate).format('M月D日')}达到最多。
            </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <div>
            <ExportEcharts option={this.state.polar}></ExportEcharts>
          </div>
          <div>
            <ExportEcharts option={this.state.bar}></ExportEcharts>
          </div>
        </div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P8);



// WEBPACK FOOTER //
// src/routes/exportPDF/p8/p8.js